import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { isVendor as checkIsVendor } from "../../types/jwt";

interface AuthState {
    token: string | null;
    userType: "User" | "Guest" | null;
    isVendor: boolean;
}

const initialState: AuthState = {
    token: null,
    userType: null,
    isVendor: false,
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setCredentials: (
            state: AuthState,
            action: PayloadAction<{ token: string; userType: "User" | "Guest" }>
        ) => {
            state.token = action.payload.token;
            state.userType = action.payload.userType;
            state.isVendor = checkIsVendor(action.payload.token);

            localStorage.setItem("auth_token", action.payload.token);
            localStorage.setItem("userType", action.payload.userType);
        },
        loginAsGuest: (
            state: AuthState,
        ) => {
            state.userType = "Guest";
            state.isVendor = false;
            localStorage.setItem("userType", "Guest");
        },
        loginExpired: (state: AuthState) => {
            state.token = null;
            state.userType = null;
            state.isVendor = false;

            localStorage.removeItem("auth_token");
            localStorage.removeItem("userType");
        },
        logout: (state: AuthState) => {
            state.token = null;
            state.userType = null;
            state.isVendor = false;

            localStorage.removeItem("auth_token");
            localStorage.removeItem("userType");
        },
        loadFromStorage: (state: AuthState) => {
            const token = localStorage.getItem("auth_token");
            const userType = localStorage.getItem("userType") as "User" | "Guest" | null;
            state.token = token;
            state.userType = userType;
            state.isVendor = token ? checkIsVendor(token) : false;
        },
    },
});

export const { setCredentials, loginAsGuest, logout, loadFromStorage, loginExpired } =
    authSlice.actions;
export default authSlice.reducer;
